/* CG Shop — Products landing behaviour.
   Series tabs (mobile), wellness-goal nav/accordion, ?goal= deep link.
   Add to Cart is handled by the theme's <xo-cart-add> component. */

(() => {
  'use strict';

  const DESKTOP = window.matchMedia('(min-width: 992px)');

  /* ---- Series: mobile tab switcher ---- */
  const initSeries = (root) => {
    if (root.hasAttribute('data-cg-init')) return;
    root.setAttribute('data-cg-init', '');

    const tabs = [...root.querySelectorAll('[data-cg-tab]')];
    const panels = [...root.querySelectorAll('[data-cg-series-panel]')];
    if (!tabs.length) return;

    const select = (index) => {
      tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
    });
    select(0);
  };

  /* ---- Goals: desktop nav / mobile single-open accordion ---- */
  const initGoals = (root) => {
    if (root.hasAttribute('data-cg-init')) return;
    root.setAttribute('data-cg-init', '');

    const headers = [...root.querySelectorAll('[data-cg-goal-header]')];
    const panels = [...root.querySelectorAll('[data-cg-goal-panel]')];
    if (!headers.length) return;

    const setOpen = (index, open) => {
      headers[index].classList.toggle('is-active', open);
      headers[index].setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panels[index]) panels[index].classList.toggle('is-active', open);
    };

    const activate = (index) => {
      headers.forEach((_, i) => setOpen(i, i === index));
    };

    const openIndex = () => headers.findIndex((header) => header.classList.contains('is-active'));

    headers.forEach((header, i) => {
      header.addEventListener('click', () => {
        if (DESKTOP.matches) {
          activate(i);
        } else if (header.classList.contains('is-active')) {
          setOpen(i, false); // accordion: re-tap closes
        } else {
          activate(i);
        }
      });
    });

    // Desktop always needs one active goal (mobile may have closed all).
    DESKTOP.addEventListener('change', (event) => {
      if (event.matches && openIndex() === -1) activate(0);
    });

    // ?goal=<slug> deep link (from the landing wellness-solutions cards).
    const slug = new URLSearchParams(window.location.search).get('goal');
    const target = slug
      ? headers.findIndex((header) => header.getAttribute('data-goal') === slug)
      : -1;
    activate(target === -1 ? 0 : target);
    if (target !== -1) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-cg-shop-series]').forEach(initSeries);
    document.querySelectorAll('[data-cg-shop-goals]').forEach(initGoals);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target
      .querySelectorAll('[data-cg-shop-series], [data-cg-shop-goals]')
      .forEach((el) => el.removeAttribute('data-cg-init'));
    initAll();
  });
})();
